import {useContext} from 'react'

import UserContext from './UserContext'

const useUserContext = () => {
  const user = useContext(UserContext)
  if (!user) {
    throw new Error('Missing UserContextProvider in its parent.')
  }
  return user
}

export default useUserContext
